import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class PressSlider {
    constructor($el) {
        this.$el = $el;

        this.options = {
            // autoPlay: true,
            pageDots: true,
            wrapAround: true,
            prevNextButtons: true,
            freeScroll: true,
            cellSelector: '.home-press__slider-item',
            cellAlign: 'left',
            imagesLoaded: true,
            //arrowShape: 'M74.681.837a2.002 2.002 0 0 0-2.41.377c-.579.609-.758 1.329-.383 2.185.047.108.352.797 1.372 1.178.831.31 3.802 1.249 5.96 2.619.47.298.898.613 1.228.956.182.188.409.325.383.542-.067.549-.394 1.015-.821 1.456-.628.646-1.476 1.208-2.419 1.726-3.383 1.858-7.886 3.102-10.043 4.239a2.001 2.001 0 0 0 1.866 3.539c2.171-1.145 6.699-2.403 10.103-4.272 2.908-1.597 4.981-3.715 5.284-6.204.192-1.574-.603-3.145-2.169-4.445-2.41-2.001-6.799-3.468-7.951-3.896Zm.943 1.142a1.998 1.998 0 0 1-.382 1.91c.479-.543.642-1.175.382-1.91Zm-.011-.033.007.021-.005-.015-.002-.006Z'
        };

        if(this.$el.length) {
            this._init();
        }
    }

    _init() {
        this.$slides = this.$el.find('.home-press__slider-item');
        this.slidesCount = this.$slides.length;

        if(this.slidesCount > 0) {
            this._createSlider();
        }
    }

	_createSlider() {
        new Flickity(this.$el[0], this.options);
    }
}

export default PressSlider;
